import React,{useState,useEffect,useContext} from 'react'
import Loading from '../../components/Loading/index.js'
import LoadingFailed from '../../components/LoadingFailed/index.js'
import { useParams } from 'react-router';
import axios from 'axios'
import PrefixContext from '../../context/PrefixContext.js'
import {Link} from 'react-router-dom'

function Index() {

    const { id,otp } = useParams();
    const [loading, setloading] = useState('LOADING');
    const PrefixContextData = useContext(PrefixContext);


    const verfiyUser = () => {
        axios.get(PrefixContextData.prefixUrl+'user/verify/'+id+'/'+otp)
            .then(response => {
                if(response.status === 200){
                    setloading('LOADED')
                }
                else{
                    setloading('FAILED')
                }
            })
            .catch(error => {
                setloading('FAILED')
            });
    }

    useEffect(() => {
        verfiyUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        <>
            {loading === 'LOADING' && <Loading  type="withImage" />}
            {loading === 'LOADED' && 
                <div className="new-section page-heading-margin bg-secondary d-flex">
                    <h5 className="my-auto mx-auto">User Email Verified Successfully. Click <Link className="text-primary" to="/login">here</Link> to Login ...</h5>
                </div>
            }
            {loading === 'FAILED' && 
                <div className="new-section page-heading-margin bg-secondary d-flex flex-column justify-content-center">
                    <LoadingFailed type="withImage" label="Something went wrong please retry using the resend email verification link button on login page" />
                </div>
            }
        </>
    )
}

export default Index
